module.exports = __webpack_public_path__ + "static/media/snooker.eea27742.png";